import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outcome-information-popover',
  templateUrl: './outcome-information-popover.component.html',
  styleUrls: ['./outcome-information-popover.component.scss'],
})
export class OutcomeInformationPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
